import jsPDF from 'jspdf';
import { calcMonthlyStats } from './turniStats';
import { monthLabel, buildDayRows } from './turniPdfHelpers';
import { renderPageHeader, buildSaldoCell, renderStatsTable, renderDayTable, renderNightSection } from './turniPdfDraw';

export const generateMensialePdf = ({ allDays, collaboratorsList, turniData, managerFerieList, reperibilitaData = [], cumulativeBalances = {} }) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const periodo = allDays[0]?.fullDate ? monthLabel(allDays[0].fullDate) : '';
  const today = new Date().toLocaleDateString('it-IT');
  const pageW = doc.internal.pageSize.width;
  const pageH = doc.internal.pageSize.height;

  collaboratorsList.forEach((user, idx) => {
    if (idx > 0) doc.addPage();
    const uName = `${user.nome} ${user.cognome}`.trim();
    renderPageHeader(doc, uName, periodo, today, pageW);
    const stats = calcMonthlyStats(allDays, turniData, managerFerieList, user, reperibilitaData);
    const oreEffettive = +Number(stats.workedHours + stats.ferieHours + stats.permessiHours + stats.malattiaHours).toFixed(1);
    const saldo = cumulativeBalances[uName] !== undefined ? cumulativeBalances[uName] : null;
    renderStatsTable(doc, stats, oreEffettive, buildSaldoCell(saldo));
    renderDayTable(doc, buildDayRows(allDays, turniData, managerFerieList, uName, reperibilitaData));
    renderNightSection(doc, { uName, turniData, allDays, pageH });
    doc.setFontSize(8);
    doc.setTextColor(160);
    doc.text(`Casa Letizia — Documento riservato — ${today}`, 14, pageH - 8);
    doc.setTextColor(0);
  });

  return doc;
};
